import { MapPin } from "lucide-react";

const REGION_LABELS: Record<string, string> = {
  US: "US-Specific",
  UK: "UK-Specific",
  India: "India-Specific",
};

/**
 * A small, honest heads-up badge for tools whose logic is tied to one
 * country's rules -- not a quality flag, just making sure someone doesn't
 * assume a tool applies to them when it doesn't. Renders nothing if the
 * tool has no region set.
 */
export function RegionBadge({ region }: { region?: string }) {
  if (!region) return null;
  const label = REGION_LABELS[region] || `${region}-Specific`;

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-400 border border-amber-200 dark:border-amber-900">
      <MapPin className="h-3 w-3" />
      {label}
    </span>
  );
}
